import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Chip, ChipProps } from '@frontend/design-system';
import { SharedNodeProps } from '../data';
import { INCOMING_DIALABLES_SOURCE_HANDLE_ID } from './incoming-dialables-node';
import { draggableStyles } from './styles';

export const StartNode = memo(({ data, isDeviceExtensionRoute }: SharedNodeProps) => {
  const { t } = useTranslation('phone');

  return (
    <div css={draggableStyles}>
      <PhoneChip isDeviceExtensionRoute={isDeviceExtensionRoute}>
        {isDeviceExtensionRoute ? data.label : t('Incoming Call')}
      </PhoneChip>
      <Handle
        type='source'
        position={Position.Bottom}
        id={data.id}
        isConnectable={true}
        style={{ visibility: 'hidden' }}
      />
      <Handle
        type='source'
        position={Position.Right}
        id={INCOMING_DIALABLES_SOURCE_HANDLE_ID}
        isConnectable={true}
        style={{ visibility: 'hidden' }}
      />
    </div>
  );
});
StartNode.displayName = 'StartNode';

const PhoneChip = (props: ChipProps & { isDeviceExtensionRoute?: boolean }) => {
  const { isDeviceExtensionRoute, ...rest } = props;
  return (
    <Chip
      maxWidth={'200px'}
      css={{ background: theme.colors.neutral90, color: theme.colors.white }}
      leftElement={<Icon name={isDeviceExtensionRoute ? 'phone-forward-small' : 'phone-call-small'} />}
      {...rest}
    />
  );
};
